"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withQueryContainer = void 0;

var _reactDom = _interopRequireDefault(require("react-dom"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _resizeObserver = require("resize-observer");

var _matchQueries = _interopRequireDefault(require("./matchQueries"));

var _unitToPx = _interopRequireDefault(require("./utils/unit-to-px"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var QueryContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(QueryContainer, _Component);

  function QueryContainer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, QueryContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(QueryContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      additionalClassNames: []
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function (entry) {
      if (entry.length !== 1) return;
      var _entry$0$contentRect = entry[0].contentRect,
          width = _entry$0$contentRect.width,
          height = _entry$0$contentRect.height;
      var result = (0, _matchQueries["default"])(_this.parseQueryUnits(_this.props.query), {
        width: width,
        height: height
      });

      _this.setState({
        additionalClassNames: result
      });
    });

    _defineProperty(_assertThisInitialized(_this), "parseQueryUnits", function (queries) {
      return Object.keys(queries).reduce(function (accumulator, key) {
        accumulator[key] = _this.parseSingleQuery(queries[key]);
        return accumulator;
      }, {});
    });

    _defineProperty(_assertThisInitialized(_this), "parseSingleQuery", function (query) {
      return Object.keys(query).reduce(function (accumulator, innerKey) {
        var prop = innerKey.match(/[A-Z]\w*$/)[0].toLowerCase();
        accumulator[innerKey] = (0, _unitToPx["default"])(_this.element, query[innerKey], prop);
        return accumulator;
      }, {});
    });

    return _this;
  }

  _createClass(QueryContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.element = _reactDom["default"].findDOMNode(this);
      this.observer = new _resizeObserver.ResizeObserver(this.handleResize);
      this.observer.observe(this.element);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.observer.disconnect();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          query = _this$props.query,
          props = _objectWithoutProperties(_this$props, ["children", "query"]);

      return _react["default"].Children.map(this.props.children, function (child) {
        return _react["default"].cloneElement(child, _objectSpread({}, props, {
          className: (0, _classnames["default"])(child.props.className, _this2.state.additionalClassNames)
        }));
      });
    }
  }]);

  return QueryContainer;
}(_react.Component);

var withQueryContainer = function withQueryContainer(Component, query) {
  return _react["default"].forwardRef(function (props, ref) {
    return _react["default"].createElement(QueryContainer, {
      query: query
    }, _react["default"].createElement(Component, _extends({}, props, {
      ref: ref
    })));
  });
};

exports.withQueryContainer = withQueryContainer;